import {Injectable} from "@angular/core";
import {QuestionType} from "./api/data-model";

export enum ContentProgression {
    LOCKED = <any>"RA_Strict",
    STUDENT_SELECTED = <any>"RA_Relaxed",
    UNLOCKED = <any>"Normal"
}

@Injectable()
export class Scilearn {

    public static KEYCHAIN_ACCESS_GROUP = "S83ZU8S2Z2.FastForWord";
    public static WORD_CATEGORY_GLUE = "1";
    public static WORD_CATEGORY_DEFAULT = "2";
    public static WORD_CATEGORY_TARGET = "3";
    public static WORD_CATEGORY_SPECIAL = "4";
    public static RECOGNITION_ERROR_THRESHOLD = 100;
    public static __GLOSSARY__ = "Glossary";
    public static __READTOME__ = "ReadToMe";
    public static __PLAYBACK__ = "Playback";
    public static QUIZ_QUESTION = "Q";
    public static THINK_ABOUT_IT = "GR";
    public static _TRAINING_TIMER = "training_timer";
    public static _INACTIVE_TIMER = "inactive_timer";
    public static MESSAGE_MODAL = "message_modal";
    public static TIMEOUT_MODAL = "timeout_modal";
    public static MICROPHONE_CHECK_MODAL = "microphone_check_modal";
    public static FLUENCY_MODAL = "fluency_modal";
    public static SELECTION_MODAL = "selection_modal";
    public static BOOKSESSION_KEY = "_bookSessionId";
    public static PIPELINE_MODAL = "pipeline_modal";
    public static CREDITS_MODAL = "credits_modal";
    public static HELP_MODAL = "help_modal";
    public static SYSINFO_MODAL = "sysinfo_modal";
    public static QUESTIONTYPE_MULTICHOICE = "MultipleChoice" as QuestionType;
    public static QUESTIONTYPE_MULTICHECKS = "MultipleChecks" as QuestionType;
    public static QUESTIONTYPE_PROMPT = "Prompt" as QuestionType;
    public static QUESTIONTYPE_OPENBOOK = "OpenBook" as QuestionType;
    public static QUESTIONTYPE_TRUEFALSE = "TrueFalse" as QuestionType;
}

// Enums for error logging/ Bugsnag
export enum Severity {
    DEBUG = "debug", /*NOTE: debug has no meaning to BugSnag, only internally*/
    INFO = "info",
    WARNING = "warning",
    ERROR = "error"
}

export enum ErrorType {
    MICROPHONE = "Microphone",
    PLAYBACK = "Audio Playback",
    CONNECTION = "Connection/Server State",
    CONTENT_SERVER = "Content Server",
    USER_STATE = "User State",
    EVENT_LOOP = "Reading Component Event Loop",
    RECOGNIZER = "Recognizer Worker"
}

// Enum for tracking different steps
export enum BookSessionType {
    WORDWALL = <any>"WordWall",
    PREVIEW = <any>"Preview",
    FLUENCY = <any>"Fluency",
    QUIZ = <any>"Quiz"
}

// Enum for type of intervention when user is reading aloud
export enum INTERVENTIONTYPE {
    no_intervention = 0,
    visual_intervention = 1,
    audio_intervention = 2
}

// Enums for content production tool/pipeline
export enum AudioState {
    UNKNOWN = "Unknown",
    UNRECORDED = "Unrecorded", // initial state on import
    SCRIPTED = "Scripted", // audio scripts have been created
    UPLOADED = "Uploaded", // audio has been uploaded and synced to S3 (happens outside of CPT)
    UPLOAD_CONFIRMED = "Upload Confirmed", // audio has been confirmed to exist and be playable (but not necessarily 'correct')
    VERIFIED = "Verified", // audio has been tested and verified as correct (happens outside of CPT)
    RERECORD = "Rerecord", // text has changed or audio has been noted to be wrong/poor quality
    MISSING = "Missing" // audio has been noted to be missing in manual or automatic testing
}
